import moment from 'moment'
import React, { useState } from 'react'
import LeaveSVG from '../../../../assets/svg/hr/hr-leave-new.svg'
import SalaryAdvanceSVG from '../../../../assets/svg/hr/hr-salary-advance-new.svg'
import ReimbursementsSVG from '../../../../assets/svg/hr/hr-reimbusment-new.svg'
import { useHistory } from 'react-router-dom'
import HROverviewChart from './HROverviewChart'

export const HRRequests = ({ requests, donutData }) => {
  const [period, setPeriod] = useState('this_week')

  const history = useHistory()
  return (
    <div
      className={`flex flex-col h-[300px] w-[100%] p-2 align-center bg-white border rounded-[5px]`}
    >
      <div className='text-[20px] p-2 leading-[20px] font-medium text-black/70'>
        Requests
      </div>
      <hr className='divider' />

      <div className='flex px-2 items-center justify-between mb-2'>
        <div className='text-sm font-medium text-black/70'>Request type</div>
        <div className='text-sm font-medium text-black/70'>Total Requests</div>
      </div>
      <div className='flex flex-col gap-1'>
        {/* <div
          className='flex  items-center justify-between hover:bg-gray-100 cursor-pointer px-2 py-2 transition-all duration-300'
          // onClick={() => {
          //   history.push('/employees', 1)
          // }}
        >
          <div className='flex flex-row gap-2 items-center justify-center'>
            <img src={SalaryAdvanceSVG} alt='' />
            <p className='text-sm font-medium text-black/50'>Salary Advance</p>
          </div>
          <div className='text-sm font-medium text-black/50 mr-10'>
            {requests.advance_request}
          </div>
        </div> */}
        <div
          className='flex  items-center justify-between hover:bg-gray-100 cursor-pointer px-2 py-2 transition-all duration-300'
          onClick={() => {
            history.push('/leave/applications')
          }}
        >
          <div className='flex flex-row gap-2 items-center justify-center'>
            <img src={LeaveSVG} alt='' />
            <p className='text-sm font-medium text-black/50'>Leave</p>
          </div>
          <div className='text-sm font-medium text-black/50 mr-10'>
            {requests.leave_requests ?? 0}
          </div>
        </div>
        {/* <div
          className='flex  items-center justify-between hover:bg-gray-100 cursor-pointer px-2 py-2 transition-all duration-300'
          // onClick={() => {
          //   history.push('/employees', 1)
          // }}
        >
          <div className='flex flex-row gap-2 items-center justify-center'>
            <img src={ReimbursementsSVG} alt='' />
            <p className='text-sm font-medium text-black/50'>Reimbursements</p>
          </div>
          <div className='text-sm font-medium text-black/50 mr-10'>
            {requests.leave_requests}
          </div>
        </div> */}
      </div>
      <div className='w-[100%] h-fit pl-2'>
        <HROverviewChart data={donutData} />
      </div>
    </div>
  )
}
